/** Supports multi-part TLDs like .com.au, .co.in, .co.uk. */
export const DOMAIN_REGEX =
  /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,}){1,3}$/;

export function isValidDomain(value: string): boolean {
  return DOMAIN_REGEX.test(value);
}

/** Mantine `useForm` style validator, shared between the onboarding and post-onboarding company profile forms so they stay in sync. */
export function validateDomain(value: string | undefined): string | null {
  if (!value) {
    return 'Company domain is required';
  }
  if (!isValidDomain(value)) {
    return 'Please enter a valid domain (e.g., example.com or example.com.au)';
  }
  return null;
}
